import { Button, ButtonTheme } from '@apply/components';

export const MakeAnotherPaymentButton = () => {
    return (
        <>
            <Button
                id='makeAnotherPaymentButton'
                theme={ButtonTheme.Primary}
                type='button'
                width='220px'
                handleClick={() => (window.location.href = '/payment')}
            >
                Make Another Payment
            </Button>
        </>
    );
};
